/**
 * Question Routes
 *
 * Titles/descriptions/breadcrumbs are auto-resolved by the i18n router
 * guard from each route's `name` — see `src/plugins/i18n/routeI18n.ts`.
 */

import { Role } from '../../types'

export default [
  {
    path: 'questionCategories',
    name: 'questions.categories',
    component: () => import('../../pages/questions/CategoriesView.vue'),
    meta: {
      requiresAuth: true,
      roles: ['ai_lab_admin', 'ai_lab_user'] as Role[]
    }
  },
  {
    path: 'questions/category/:category',
    name: 'questions.overview',
    component: () => import('../../pages/questions/OverallView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: 'questions/:questionID',
    name: 'questions.detail',
    component: () => import('../../pages/questions/DetailView.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'questions.detail.default',
        component: () => import('../../pages/questions/tabs/DetailsTab.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'gatekeeper',
        name: 'questions.detail.gatekeeper',
        component: () => import('../../pages/questions/tabs/RedirectTab.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'options',
        name: 'questions.detail.options',
        component: () => import('../../pages/questions/tabs/OptionsTab.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'followups',
        name: 'questions.detail.followups',
        component: () => import('../../pages/questions/tabs/ConditionsTab.vue'),
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: 'options/:questionID',
    name: 'questions.optionsPage',
    component: () => import('../../pages/questions/options/OptionsPage.vue'),
    meta: { requiresAuth: true }
  }
]
